import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const RiskSafetyConcernsSection = ({
  sessionFormData,
  updateFormData,
  suicideRiskError,
  homicideRiskError,
  abuseNeglectError,
  safetyPlanNotesError,
  setSuicideRiskError,
  setHomicideRiskError,
  setAbuseNeglectError,
  setSafetyPlanNotesError
}) => {
  const handleRiskSafetyChange = (key, value) => {
    updateFormData(key, value);
    if (key === "suicideRisk" && suicideRiskError) {
      setSuicideRiskError("");
    } else if (key === "homicideRisk" && homicideRiskError) {
      setHomicideRiskError("");
    } else if (key === "abuseNeglect" && abuseNeglectError) {
      setAbuseNeglectError("");
    }
    const allNone =
      (key === "suicideRisk" ? value : sessionFormData.suicideRisk) === "None" &&
      (key === "homicideRisk" ? value : sessionFormData.homicideRisk) === "None" &&
      (key === "abuseNeglect" ? value : sessionFormData.abuseNeglect) === "None";

    if (allNone || sessionFormData.safetyPlanNotes?.trim()) {
      setSafetyPlanNotesError("");
    }
  };

  const getFieldError = (key) => {
    switch (key) {
      case "suicideRisk":
        return suicideRiskError;
      case "homicideRisk":
        return homicideRiskError;
      case "abuseNeglect":
        return abuseNeglectError;
      default:
        return "";
    }
  };

  const riskSafetyFields = [
    {
      key: "suicideRisk",
      label: "Suicide Risk",
      options: ["None", "Low", "Moderate", "High", "Unable to assess"]
    },
    {
      key: "homicideRisk",
      label: "Homicide Risk",
      options: ["None", "Low", "Moderate", "High", "Unable to assess"]
    },
    {
      key: "abuseNeglect",
      label: "Abuse/Neglect",
      options: ["None", "Suspected", "Confirmed", "Historical", "Unable to assess"]
    }
  ];

  return (
    <Card id="risk-safety" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Risk & Safety
      </h3>

      {riskSafetyFields.map((field) => {
        const showWarning = sessionFormData[field.key] && sessionFormData[field.key] !== "" && sessionFormData[field.key] !== "None";
        const fieldError = getFieldError(field.key);

        return (
          <div key={field.key} style={{ marginBottom: "18px" }}>
            <label className={styles.labelWithMarginXLarge}>
              {field.label}:
            </label>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <select
                value={sessionFormData[field.key] || ""}
                onChange={(e) => handleRiskSafetyChange(field.key, e.target.value)}
                className={styles.selectMediumWidth}
              >
                <option value="">–</option>
                {field.options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {fieldError && (
                <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
                  {fieldError}
                </div>
              )}
              {showWarning && (
                <div style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  color: "#FF9500",
                  fontStyle: "italic",
                  textAlign: "left"
                }}>
                  Please document safety plan or follow-up in notes below.
                </div>
              )}
            </div>
          </div>
        );
      })}

      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <label className={styles.labelWithMargin}>
            Safety Plan / Notes (if applicable)
          </label>
          <div style={{ marginTop: "4px", fontSize: "12px", color: "#8E8E93" }}>
            {sessionFormData.safetyPlanNotes?.length || 0}/500
          </div>
        </div>
        {safetyPlanNotesError && (
          <div className={styles.errorMessage} style={{ marginTop: "8px" }}>
            {safetyPlanNotesError}
          </div>
        )}
        <textarea
          value={sessionFormData.safetyPlanNotes || ""}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 500) {
              updateFormData("safetyPlanNotes", value);
              if (safetyPlanNotesError) {
                setSafetyPlanNotesError("");
              }
            }
          }}
          placeholder="Free Text"
          className={styles.textarea}
          maxLength={500}
        />
      </div>
    </Card>
  );
};

export default RiskSafetyConcernsSection;

